export default __webpack_public_path__ + "static/media/bitwallet-swissMarkets-dark.3d6a8cac.svg";